import { useTranslation } from "react-i18next";

import { Props, AbsenceStatusOptionValue, AbsenceStatusQuickFilter } from "./interfaces";
import { QuickFilterOption } from "../../../reusable-components/QuickFilter/interfaces";
import QuickFilter from "../../../reusable-components/QuickFilter/QuickFilter";

export const AbsencesStatusesQuickfilter = <Q extends AbsenceStatusQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
  isMultiSelect,
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.absences_statuses"; // tRP - translation root path

  const options: QuickFilterOption<AbsenceStatusOptionValue>[] = [
    {
      name: t(`${tRP}.all_statuses`),
      value: { absenceStatuses: [] },
    },
    {
      name: t(`${tRP}.approved`),
      value: { absenceStatuses: [{ approved: true }] },
    },
    {
      name: t(`${tRP}.rejected`),
      value: { absenceStatuses: [{ rejected: true }] },
    },
    {
      name: t(`${tRP}.cancelled`),
      value: { absenceStatuses: [{ cancelled: true }] },
    },
    {
      name: t(`${tRP}.pending`),
      value: { absenceStatuses: [{ pending: true }] },
    },
    {
      name: t(`${tRP}.cancell_request`),
      value: { absenceStatuses: [{ cancellationRequestPending: true }] },
    },
    {
      name: t(`${tRP}.pending_for_client`),
      value: { absenceStatuses: [{ pendingForClient: true }] },
    },
  ];

  return (
    <QuickFilter
      options={options}
      quickFilters={quickFilters}
      quickFilter="absencesStatuses"
      handleChangeQuickFilter={handleChangeQuickFilters}
      shrinkedLabel={t(`${tRP}.shrinked_label`)}
      isMultiSelect={isMultiSelect}
      multiSelectField="absenceStatuses"
      customWidth={"200px"}
    />
  );
};
